import { BarChart3, Lock } from 'lucide-react';

export default function Analytics() {
  return (
    <div className="max-w-6xl mx-auto space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Analytics</h1>
        <p className="text-sm text-slate-500 mt-1">
          Track your outbound performance metrics.
        </p>
      </div>

      {/* Stats Grid - locked */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {[
          { title: 'Emails Sent', value: '0' },
          { title: 'Open Rate', value: '0%' },
          { title: 'Reply Rate', value: '0%' },
        ].map(({ title, value }) => (
          <div key={title} className="bg-white border border-slate-200 rounded-xl p-6 relative">
            <div className="absolute inset-0 bg-white/60 backdrop-blur-[1px] rounded-xl flex items-center justify-center z-10">
              <div className="flex items-center gap-1.5 text-slate-400 text-xs font-medium">
                <Lock className="w-3.5 h-3.5" />
                <span>Coming Soon</span>
              </div>
            </div>
            <p className="text-sm text-slate-500">{title}</p>
            <p className="text-3xl font-bold text-slate-900 mt-1">{value}</p>
          </div>
        ))}
      </div>

      {/* Empty State */}
      <div className="bg-slate-50 border border-slate-200 rounded-xl p-12 text-center">
        <BarChart3 className="w-12 h-12 mx-auto text-slate-300 mb-4" />
        <div className="flex items-center justify-center gap-2 mb-2">
          <Lock className="w-4 h-4 text-slate-400" />
          <h2 className="text-lg font-semibold text-slate-900">Coming Soon</h2>
        </div>
        <p className="text-sm text-slate-500">
          Analytics will be available once the campaign and inbox features are enabled.
        </p>
      </div>
    </div>
  );
}
